<script setup lang="ts">
import { reportService } from "@/services/report-service";
import { notificationsService } from "@/services/notifications-service";
import { onBeforeMount, ref, toRefs } from "vue";
import type { ReportsDTO } from "@/models/dtos/reports-dto";

const props = defineProps<{ reportId: number | string }>();
const { reportId } = toRefs(props);

const pageLoading = ref(false);
const report = ref<ReportsDTO | undefined>();

onBeforeMount(async () => {
  try {
    pageLoading.value = true;
    report.value = await reportService.getReport(reportId.value);
  } catch (error) {
    notificationsService.open({
      text: "Något gick fel vid hämtning av rapporten.",
      type: "error",
      error,
    });
  } finally {
    pageLoading.value = false;
  }
});
</script>

<template>
  <section class="section px-0">
    <p class="title is-4">{{ report?.name }}</p>
    <app-loader v-if="pageLoading"></app-loader>
    <div class="column is-8">
      <div
        v-for="(attr, index) in report?.attributes"
        :key="index"
        class="field"
      >
        <label class="label">{{ attr.name }}</label>
        <label>{{ attr.value }}</label>
      </div>
    </div>
  </section>
</template>
